export default function MySQL_UNIONALL() {
  return (
    <div>
      <h2>MySQL_UNIONALL</h2>    </div>
  );
}